import type { FaireProductEntity } from "../../entity_types/product";

export const p_h9qbsvw45s: FaireProductEntity = {
  token: "p_h9qbsvw45s",
  type: "product",
  name: "Arroyo Oak – 7.2 oz Standard Candle",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/19800c1b5f1f439c0bfa532b2816184a75a067262379ffbae42d4587bb66d492.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/83277f68f121c6a2af8c450be2758e75314ffd6ef54097511efc5ca1302ebdac.jpeg",
    "https://cdn.faire.com/fastly/76fd2292ed235f0b4e9fbb117085257da8e3f4b1edc57718da3f64c44b3d7a67.jpeg",
    "https://cdn.faire.com/fastly/8479783f8f591f2687ade0bb2407b2055c3cb5d8960ea447860a4a5ff40d9c4a.png",
    "https://cdn.faire.com/fastly/4afab458078f2498b5062052fc198c2520be8310e89e643631ce5314af81d552.jpeg",
    "https://cdn.faire.com/fastly/c49631d3764c8627019b9c648e9fbe03227a92b230c0814d52d2c721eefc2c95.jpeg",
    "https://cdn.faire.com/fastly/c759dda0d044a80b01fbeb2139253697c54d28a43f969447ee72db520a9d08ea.jpeg",
    "https://cdn.faire.com/fastly/cd9799d155f80e4186606a533e238f812bedf5fb2ba679aa8f330d84d8b1c69a.jpeg",
  ],
  priceDollars: 11,
  description:
    "A love letter to the quiet wild of the Arroyo Seco. A passageway of twisted terrain perfumed by native sagebrush, crushed oak leaves, shady creek beds, and canyon stone. Vetiver, frankincense, & California oak.\n\nThis is our most popular size and is meant for dressers, countertops, nightstands – basically everywhere. \n\n Our best-selling 7.2 oz Standard Size.This is our most popular size and is meant for dressers, countertops, nightstands – basically everywhere. \n\nHand-poured into apothecary inspired amber jars with our signature kraft label and a brass lid. Our candles are simple - they're all made with 100% domestically grown soy wax, fine fragrance oils, and cotton-core wicks. The fragrances we use are paraben-free, phthalate-free, and never (ever) tested on animals.\n\nBurns for 40-50 hours.",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:49.635Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
